import {connect} from 'react-redux';
import DateTimeFilterDesktop from '@peoplenet/vi-components-ui/src/NewLibraryFilter/component/DateTimeFilterDesktop';
import React from 'react';
import {I18n} from 'react-redux-i18n';
import moment from 'moment';
import ReactGA from 'react-ga';
import Chips from '../../components/Chips';
import {searchMedias} from '../../Library/LibraryActions';
import { find, findIndex } from 'lodash';
class ActiveFilterChips extends React.Component {
    chipIdSeparator = "$@@$$&&##**$";
    constructor(props) {
        super(props); 
        this.state = {
            selectedFilters: []
        }       
    }

    updateFromProps(props) {
        const {
            terminalsFilter, terminals,
            groupsFilter, groups,
            oerTypeFilter, oerTypes,
            sortBy, constrainedFilters,
            startTime, endTime, mediaId, chipsFilter
        } = props;
      
        this.state = {
            terminals, terminalsFilter,
            groups, groupsFilter,
            oerTypes, oerTypeFilter,
            sortBy, constrainedFilters,
            startTime, endTime, mediaId, chipsFilter, selectedFilters: this.updateChipsWithSelectedFilters() 
        };
    }
    
    componentWillReceiveProps(props) {
        // console.error("props are 2: ",props);
        this.updateFromProps(props);
        this.showDefaultDateChip();
    }
    /**
     * Method to check whether selectedFilters contains the dateTimeFilter.
     * If not, then we will push the default 30 days filter object with props like isDefault & hideDelete set
     * If yes, then we will check the label is default 30 days and set the props of isDefault, hideDelete
     */
    showDefaultDateChip(){
        const defaultDateRange = "Last 30 Days";
        let dateTimeFilter = find(this.state.selectedFilters, (item) => item.id === 'dateTimeFilter');
        if(this.state.selectedFilters && (this.state.selectedFilters.length == 0 || !dateTimeFilter)){
            this.state.selectedFilters.unshift({id: 'dateTimeFilter', label: defaultDateRange, hideIcon: true, hideDelete: true, isDefault: true});
        } 
        if(dateTimeFilter && dateTimeFilter.label === defaultDateRange){
            dateTimeFilter.hideDelete = true;
            dateTimeFilter.isDefault = true;
        }
    }

    getChipLabel(id, parentArray) {
        let selectedArray = [];
        if(parentArray.length > 0){
            selectedArray = parentArray.find(object => object.id === id);
            if(!selectedArray){
                selectedArray = parentArray.flatMap(object => object.children).find(object => object && object.id === id);
            }
        }
        return selectedArray ? (selectedArray.selectedLabel || selectedArray.name)  : '';
    }

    handleOnRemoveChip = (event, chip) => {
        let chipIdentifier = chip.id.split(this.chipIdSeparator)[0];
        let chipId = chip.id.split(this.chipIdSeparator)[1];
        this.props.updateActiveFilterChips(chipIdentifier, chipId);
    
        ReactGA.event({
          category: 'Library Filter',
          action: 'Remove Chip',
          label: 'Filter Chips'
        });
    }

    getDateTimeLabel = (startTime, endTime) => {
        let label = null;
        Object.keys(DateTimeFilterDesktop.ranges).some(key => {
          const item = DateTimeFilterDesktop.ranges[key];
          if (item.startTime.valueOf() === startTime &&
            item.endTime.valueOf() === endTime) {
            label = I18n.t(`filter.date.range.${item.label}`)
          }
        });
        if (!label) {
          const format = 'YYYY-MM-DD';
          label = `${moment(startTime).format(format)} - ${moment(endTime).format(format)}`;
        }
        return label;
      }

    updateChipsWithSelectedFilters() {
        let chipObj = {};
        let addedFilters = [];
        if(this.state && this.state.startTime && this.state.endTime){
            const dateTimeLabel = this.getDateTimeLabel(this.state.startTime, this.state.endTime);
            chipObj = {id: 'dateTimeFilter', label: dateTimeLabel, hideIcon: true};
            addedFilters.push(chipObj);
        }
        if(this.state && this.state.terminalsFilter && this.state.terminalsFilter.length > 0){
            this.state.terminalsFilter.map((val)=>{
                chipObj = {id: `terminals${this.chipIdSeparator}${val}`, label: this.getChipLabel(val, this.props.terminals), hideIcon: true};
                addedFilters.push(chipObj);
            })
        }

        if(this.state && this.state.groupsFilter && this.state.groupsFilter.length>0){
            this.state.groupsFilter.map((val)=>{
                chipObj = {id: `groups${this.chipIdSeparator}${val}`, label: this.getChipLabel(val, this.props.groups), hideIcon: true};
                addedFilters.push(chipObj);
            })
        }
        if(this.state && this.state.oerTypeFilter && this.state.oerTypeFilter.length>0){
            this.state.oerTypeFilter.map((val)=>{
                chipObj = {id: `oer${this.chipIdSeparator}${val}`, label: this.getChipLabel(val, this.props.oerTypes), hideIcon: true};
                addedFilters.push(chipObj);
            })
        }
        if(this.state && this.state.mediaId){
            chipObj = {id: 'mediaId', label: this.state.mediaId, hideIcon: true};
            addedFilters.push(chipObj);
        }
        if(this.state && this.state.constrainedFilters && Object.keys(this.state.constrainedFilters).length !== 0){
          for (let [key, value] of Object.entries(this.state.constrainedFilters)) {
            if(value === true){
              chipObj = {id: `others${this.chipIdSeparator}${key}`, label: I18n.t(`filter.constraints.${key}`), hideIcon: true};
              addedFilters.push(chipObj);
            }
          }
        }
        if(this.state && this.state.chipsFilter && this.state.chipsFilter.length>0){
            this.state.chipsFilter.map((val)=>{
                chipObj = {id: `${val.name}${this.chipIdSeparator}${val.value}`, label: val.label, type: val.name, name: val.name};
                addedFilters.push(chipObj);
            })
        }
        return addedFilters;
    }
    handleClearFilter = () => {
        this.props.clearFilter();
        ReactGA.event({
            category: 'Library Filter',
            action: 'Clear Filters',
            label: 'Clear All Button'
        });
    }
    showClearAll() {
        const filtersContainDefaultObj = find(this.state.selectedFilters, {isDefault: true});
        if(filtersContainDefaultObj){
            return this.state.selectedFilters.length > 1;
        } else {
            return this.state.selectedFilters.length > 0;
        }
    }
    render() {
        return (
            <div className="filtersChipContainer">
                <div className="chipsList">
                    <Chips
                        list={this.state.selectedFilters}
                        onRemove={this.handleOnRemoveChip}
                        truncateLabel={true}
                        showClearAll={this.showClearAll()}
                        handleClearAllFilter={this.handleClearFilter}
                    />
                </div>
                {this.props.libraryTotalCount > 0 ? <div className="videosCount">{this.props.libraryTotalCount} {this.props.libraryTotalCount === 1 ? I18n.t('page.PlayerBottomNav.video') : I18n.t('page.reports.column.videos')}</div> : ''}
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const {library} = state;
    return {
        libraryTotalCount: library.libraryTotalCount
    };
}
export default connect(mapStateToProps)(ActiveFilterChips);
